
import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function FormIPInterfaces(props) {
  const { iface, handleChangeValues, disableInput } = props;
  const checkIfaces = iface.map((int) => int.includes('_') ? int.split('_').join('.') : int)

  return (
    <div name="change-route-div" className="is-align-content-center">
      <div className="columns mx-2">
        <div className="column is-1 field mx-2">
          <div className="control">
          </div>
        </div>
        <div className="column is-2 field mt-2 my-2">
          <label className="label">IP/Sub-Rede de Destino
            <div className="control">
              <input className="input" name="srdest" type="text" placeholder="1.1.1.2" disabled={ disableInput } onBlur={(e) => handleChangeValues(e.target)} />
              <p name="srdest-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Máscara
            <div className="control">
              <input className="input" name="mask" type="text" placeholder="255.255.255.0" disabled={ disableInput } onBlur={(e) => handleChangeValues(e.target)} />
              <p name="mask-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Gateway
            <div className="control">
              <input className="input" name="gw" type="text" placeholder="1.1.1.1" disabled={ disableInput } onBlur={(e) => handleChangeValues(e.target)} />
              <p name="gw-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Interface
            <div className="control">
              <div name="iface" className="select is-fullwidth">
                <select className="select" name="iface" disabled={ disableInput } onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { checkIfaces.map((i) => <option key={ i } value={ i }>{ i }</option>) }
                </select>
                <p name="iface-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}

export default FormIPInterfaces;
